import { render } from "./ModalEditarAcomodacao.vue?vue&type=template&id=25bd40c2"
import script from "./ModalEditarAcomodacao.vue?vue&type=script&lang=js"
export * from "./ModalEditarAcomodacao.vue?vue&type=script&lang=js"

import "./ModalEditarAcomodacao.vue?vue&type=style&index=0&id=25bd40c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__